import clsx from 'clsx'
import { type FC } from 'react'

import { ACTIONS } from '@/constants/common/message.constants'

type Props = {
  prefix: string
  suffix: string
  onClick: () => void
  actionLabel?: string
  withLineBreakBeforeLink?: boolean
  className?: string
}

/**
 * Renders a "click here" style inline message with a configurable prefix/suffix and CTA handler.
 */
export const ClickHereMessage: FC<Props> = ({
  prefix,
  suffix,
  onClick,
  actionLabel = ACTIONS.SHOW_HERE,
  withLineBreakBeforeLink = false,
  className
}) => {
  return (
    <span className={clsx(['inline-block', className])}>
      <span>{prefix}</span>
      {withLineBreakBeforeLink && <br />}
      <a className="cursor-pointer text-primary underline" onClick={onClick}>
        {actionLabel}
      </a>
      <span>{suffix}</span>
    </span>
  )
}
